export enum CommandSource {
  MOBILE = 'MOBILE',
  WEB = 'WEB',
  SERVER = 'SERVER',
}
